var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticStyle:{"color":"green","font-size":"16px","width":"100%","padding":"8px","cursor":"pointer"},attrs:{"disabled":_vm.getDisabledW},on:{"click":_vm.addToQuote}},[_vm._v("\n  Agregar a cotización\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }